import * as React from "react";
import { Star } from "lucide-react";
import { Card, CardContent } from "@/components/ui/card";
import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
export default function CustomerReviews() {
  const stars = Array.from({
    length: 5
  });
  return;
}